<template>
  <div class="client-detail">
    <div @click="onClick" type="primary">查看详情</div>
    <a-modal
      :title="'查看详情：' + record.nickname"
      v-model="visible"
      :closable="false"
      :centered="true"
      :footer="null"
      @ok="handleOk"
      width="60%"
    >
      <div style="margin-bottom: 10px">
        <a-button type="primary" @click="refreshToken">
          延长 token 过期时间
        </a-button>
      </div>
      <div style="margin-bottom: 10px">
        <a-button type="primary" @click="setMaterialEnvoy">
          设为素材小使者
        </a-button>
      </div>
      <div style="margin-bottom: 10px">
        <a-button type="danger" @click="deleteUsername.dialog = true">删除用户微信ID</a-button>
      </div>
      <div>
        <span>分配给：</span>
        <a-input
          placeholder="代理商手机号"
          style="width: 200px"
          v-if="editPhone"
          v-model="agentPhone"
        ></a-input>
        <span v-else style="width: 200px">{{ record.agent_phone }}</span>
        <a-button @click="setAgentPhone(record)" style="margin-left: 10px">{{
          editPhone ? "确认" : "再分配"
        }}</a-button>
      </div>
      <div>
        <label class="info" style="width: 30%">用户 ID</label>
        {{ record.client_id }}
      </div>
      <div>
        <label class="info" style="width: 30%">openid</label>
        {{ record.open_id }}
      </div>
      <div>
        <label class="info" style="width: 30%">token</label>
        {{ record.token }}
      </div>
      <div>
        <label class="info" style="width: 30%">token 过期时间</label>
        {{ this.transform(record.token_expired_time, "yyyy-MM-dd hh:mm:ss") }}
      </div>
      <div>
        <label class="info" style="width: 30%">群发上限</label>
        {{ record.batch_send_max_count }}
      </div>
      <div>
        <label class="info" style="width: 30%">用户暗号</label>
        {{ record.say_hi_code }}
      </div>
      <div>
        <label class="info" style="width: 30%">开关状态</label>
        {{ record.func_switch }}
      </div>
      <div>
        <label class="info" style="width: 30%">订阅来源</label>
        {{
          record.subscribe === null || record.subscribe === undefined
            ? "还未获取"
            : record.subscribe.toString() === "1"
            ? this.subscribe_scene_dict[record.subscribe_scene]
            : "未订阅"
        }}
      </div>
      <div>
        <label class="info" style="width: 30%">订阅时间</label>
        {{
          record.subscribe === null || record.subscribe === undefined
            ? "还未获取"
            : record.subscribe.toString() === "1"
            ? this.transform(record.subscribe_time, "yyyy-MM-dd hh:mm:ss")
            : "未订阅"
        }}
      </div>
      <div>
        <label class="info" style="width: 30%">创建时间</label>
        {{ record.create_time }}
      </div>
      <div v-if="record.vip">
        <label class="info" style="width: 30%">企业用户过期时间</label>
        {{
          record.vip_expire_time === 0
            ? "永久"
            : this.transform(record.vip_expire_time, "yyyy-MM-dd hh:mm:ss")
        }}
      </div>
      <div style="margin: 10px 0 10px 0" v-if="record.vip">
        <a-date-picker
          format="YYYY/MM/DD HH:mm:ss"
          @change="onChange"
          :placeholder="'结束日期'"
          v-model="endTime"
          :showToday="false"
        >
        </a-date-picker>
        <a-button type="primary" @click="onVIPExpiredTimeClick(false)">
          重置企业用户过期时间
        </a-button>
        <a-button type="primary" @click="onVIPExpiredTimeClick(true)">
          永不过期
        </a-button>
      </div>
      <div>
        <a-button
          type="primary"
          @click="employeeClientAdd(record, record.username)"
        >
          开通业务员监控
        </a-button>
        <a-button type="primary" @click="setClientFuncs(record, 'level')">
          开通层级管理
        </a-button>
        <a-button type="primary" @click="setClientFuncs(record, 'chatting')">
          开通个人号
        </a-button>
        <a-button type="primary" @click="setClientFuncs(record, 'live')">
          开通群直播
        </a-button>
        <a-button type="primary" @click="setClientFuncs(record, 'api')">
          开通 API 接口
        </a-button>
        <a-button type="primary" @click="setClientFuncs(record, 'sign_in_api')">
          开通 签到API
        </a-button>
      </div>
      <div style="margin: 20px 0 10px 0">
        <div>
          <a-switch
            :default-checked="Boolean(record.mini_params_switch)"
            @change="setMiniParamsSwitch"
          />
          带参发送小程序卡片
        </div>
        <div style="margin: 10px 0 0 0" v-if="record.mini_params_switch">
          <a-button type="primary" @click="getChatroomExcel(record)">
            下载配置Excel
          </a-button>
          <a-upload
            style="display: inline-block;"
            name="file"
            accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            :file-list="fileList"
            :customRequest="uploadCommonMiniParams"
          >
            <a-button> <a-icon type="upload" /> 上传配置Excel </a-button>
          </a-upload>
          <a-upload
            style="display: inline-block;"
            name="file"
            accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            :file-list="fileList"
            :customRequest="uploadDecodeMiniParams"
          >
            <a-button> <a-icon type="upload" /> 上传屈臣氏配置Excel </a-button>
          </a-upload>
        </div>
      </div>

      <div>
        <a-switch
            :default-checked="canEveryoneUploadMaterial"
            @change="setEveryoneUploadMaterialSwitch(record.client_id)"
          />
          允许所有人上传素材
      </div>

      <div :key="flag">
        <div style="margin: 15px 0 0">
          用户类型:
          <span>{{ clientType1 }}&emsp;&emsp;&emsp;</span>
          <span v-if="clientR">老板:{{ clientR }}</span>
        </div>
        <div style="margin: 15px 0 0" v-if="clientType < 2">模块显示开关：</div>
        <a-row class="modules" v-if="clientType < 2">
          <a-col style="margin-bottom: 20px">
            <a-checkbox @change="checkAll" v-model="checkedAll"></a-checkbox>
            <span style="margin-right: 100px">全选</span>
            <div v-if="clientType === 1">
              <a-checkbox v-model="changeStaff"></a-checkbox>
              <span>修改同步到员工</span>
            </div>
          </a-col>
          <a-col v-for="module in module_switch" :key="module[0]" :span="6">
            <a-checkbox v-model="module[1]"></a-checkbox>
            <span>{{ module[2] }}</span>
          </a-col>
          <a-col class="info"
            >PS:团队协作与层级管理模块在此处加上了也不一定生效</a-col
          >
          <a-col>
            <a-button
              type="primary"
              style="margin-top: 20px"
              @click="changeModuleSwitch"
              >保存修改</a-button
            >
          </a-col>
        </a-row>
        <div class="info" v-else>该账号是子账号或员工，不可编辑</div>
      </div>

      <div>
        <p>发码监测</p>
        <a @click="getCouponStat(record)">码剩余：{{num_coupon_not_assigned}} &nbsp; &nbsp; 点击刷新</a>
        <a-button @click="uploadCoupon">上传活动码</a-button>
        <a-button @click="exportAssignedCoupon(record)">下载已发数据</a-button>
        
        <a-popconfirm
          title="Are you sure delete this task?"
          ok-text="Yes"
          cancel-text="No"
          @confirm="confirmDeleteAllCoupon"
          @cancel="cancelDeleteAllCoupon"
        >
            <a-button type="danger">清空活动码</a-button>
        </a-popconfirm>
      
      </div>
      <div v-show="showUploadBox">
          <a-upload-dragger
            name="file"
            accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            :multiple="false"
            :file-list="fileList"
            :customRequest="uploadCouponExcel"
          >
            <p class="ant-upload-drag-icon">
              <a-icon type="inbox" />
            </p>
            <p class="ant-upload-text">
              点击或拖拽上传优惠券配置表格
            </p>
            <p class="ant-upload-hint">
              <b>请以Excel形式上传</b>
            </p>
            <p class="ant-upload-hint">
              第一列：优惠券ID
            </p>
            <p class="ant-upload-hint">
              第二列：优惠券名称
            </p>
            <p class="ant-upload-hint">
              第三列：优惠券备注
            </p>
          </a-upload-dragger>
      </div>

      <a-modal v-model="deleteUsername.dialog" title="选择删除原因" ok-text="确认" cancel-text="取消" @ok="deleteClientUsername">
        <a-radio-group v-model="deleteUsername.delType">
          <a-radio :value="1">
            更换机器人类型
          </a-radio>
          <a-radio :value="2">
            用户更换微信号
          </a-radio>
        </a-radio-group>
      </a-modal>
    </a-modal>
  </div>
</template>

<script>
import AModal from "ant-design-vue/es/modal/Modal";
import AButton from "ant-design-vue/es/button/button";
import moment from "moment";
const axios = require("axios");
export default {
  name: "ClientDetail",
  components: { AButton, AModal },
  props: ["record"],
  data() {
    return {
      setAgentPhoneUrl: global.DOMAIN + "uclient/set_agent_phone",
      setMaterialEnvoyUrl: global.DOMAIN + "uclient/set_material_envoy",
      agentPhone: undefined,
      refreshTokenUrlPostFix: "UClient/refresh_token",
      refreshVIPExpireTimeUrlPostFix: "UClient/refresh_vip_expire_time",
      clientFuncsUrlPostFix: "UClient/client_funcs",
      employeeClientAddUrlPostFix: "employee/client_add",
      statCouponNumberPostFix: "CouponData/count_unassigned_coupon",
      exportAssignedCouponPostFix: "CouponData/export_assigned_coupon",
      deleteAllCouponPostFix: "CouponData/delete_all_coupon",
      uploadCouponExcelPostFix: "CouponData/upload_coupon_excel",
      changeModuleSwitchUrl: global.DOMAIN + "UClient/change_module_switch",
      getClientTypeUrl: global.DOMAIN + "UClient/get_client_type",
      setMiniParamsSwitchUrl: global.DOMAIN + "UClient/set_mini_params_switch",
      getChatroomExcelUrl: global.DOMAIN + "UClient/get_chatroom_excel",
      setMiniParamsUrl: global.DOMAIN + "UClient/set_mini_params",
      // setEveryoneUploadMaterialUrl: global.DOMAIN + "UClient/set_can_everyone_upload_materials",
      // getEveryoneUploadMaterialUrl: global.DOMAIN + "UClient/set_can_everyone_upload_materials",
      setEveryoneUploadMaterialUrl: global.DOMAIN + "UClient/set_can_everyone_upload_materials",
      getEveryoneUploadMaterialUrl: global.DOMAIN + "UClient/get_can_everyone_upload_materials",
      deleteClientUsernameUrl: global.DOMAIN + "UClient/delete_client_username",
      visible: false,
      popoverVisible: false,
      subscribe_scene_dict: {
        ADD_SCENE_SEARCH: "公众号搜索",
        ADD_SCENE_ACCOUNT_MIGRATION: "公众号迁移",
        ADD_SCENE_PROFILE_CARD: "名片分享",
        ADD_SCENE_QR_CODE: "扫描二维码",
        ADD_SCENE_PROFILE_LINK: "图文页内名称点击",
        ADD_SCENE_PROFILE_ITEM: "图文页右上角菜单",
        ADD_SCENE_PAID: "支付后关注",
        ADD_SCENE_OTHERS: "其他",
      },
      endTime: null,
      endTimestamp: 0,
      module_switch: [],
      flag: 1,
      checkedAll: false,
      clientType: 0,
      clientType1: "普通用户",
      clientR: undefined,
      changeStaff: false,
      editPhone: !this.record.agent_phone,
      token: sessionStorage.token,
      fileList: [],
      num_coupon_not_assigned: 0,
      showUploadBox: 0,
      canEveryoneUploadMaterial: this.record.can_everyone_upload_materials,
      deleteUsername: {
        'dialog': false,
        'delType': 1
      }
    };
  },
  created(){
    this.getEveryoneUploadMaterialSwitch(this.record.client_id)
  },
  computed: {
    refreshTokenUrl: function () {
      return global.DOMAIN + global.API_VERSION + this.refreshTokenUrlPostFix;
    },
    refreshVIPExpireTimeUrl: function () {
      return (
        global.DOMAIN + global.API_VERSION + this.refreshVIPExpireTimeUrlPostFix
      );
    },
    clientFuncs: function () {
      return global.DOMAIN + global.API_VERSION + this.clientFuncsUrlPostFix;
    },
    employeeClientAddUrl: function () {
      return (
        global.DOMAIN + global.API_VERSION + this.employeeClientAddUrlPostFix
      );
    },
    couponStatUrl: function () {
      return (
        global.DOMAIN + global.API_VERSION + this.statCouponNumberPostFix
      );
    },
    deleteAllCouponUrl: function () {
      return (
        global.DOMAIN + global.API_VERSION + this.deleteAllCouponPostFix
      );
    },
    exportAssignedCouponUrl: function () {
      return (
        global.DOMAIN + global.API_VERSION + this.exportAssignedCouponPostFix
      );
    },
    uploadCouponExcelUrl: function () {
      return (
        global.DOMAIN + global.API_VERSION + this.uploadCouponExcelPostFix
        // "http://127.0.0.1:8000/" + this.uploadCouponExcelPostFix
      );
    },
  },
  methods: {
    getEveryoneUploadMaterialSwitch(clientId){
      console.log("get;", clientId)
      axios.post(this.getEveryoneUploadMaterialUrl, {
          client_id: clientId,
          token: sessionStorage.token,
        })
        .then((data) => {
          if (data.data.err_code === 0) {
            console.log(data.data);
            this.canEveryoneUploadMaterial = Boolean(data.data.content.can_everyone_upload_materials)
            console.log(this.canEveryoneUploadMaterial)
          } else if (data.data.err_code === 50002) {
            console.log("token 不对，跳转登录");
            this.$router.push("/");
          }
        });
    },
    setEveryoneUploadMaterialSwitch(clientId){
      axios.post(this.setEveryoneUploadMaterialUrl, {
          client_id: clientId,
          token: sessionStorage.token,
        })
        .then((data) => {
          if (data.data.err_code === 0) {
            console.log(data.data);
          } else if (data.data.err_code === 50002) {
            console.log("token 不对，跳转登录");
            this.$router.push("/");
          }
        });
    },

    deleteClientUsername(){
      if (!this.deleteUsername.delType) {
        this.$message.warning('请选择删除原因');
        return
      }
      if (!this.record.username) {
        this.$message.warning('该用户尚未发送暗号');
        return
      }
      axios.post(this.deleteClientUsernameUrl, {
          client_id: this.record.client_id,
          token: sessionStorage.token,
          del_type: this.deleteUsername.delType
        })
        .then((data) => {
          if (data.data.err_code === 0) {
            console.log(data.data);
            window.alert("删除成功")
          } else if (data.data.err_code === 50002) {
            console.log("token 不对，跳转登录");
            this.$router.push("/");
          } else if (data.data.err_code === 20042) {
            this.$message.error(`请先解绑用户${data.data.content.desc == 'bot'? '机器人': '群'}关系后删除`, 5);
          }
          else{
            console.log(data.data)
          }
        });
      this.deleteUsername.dialog = false
    },
    onClick() {
      console.log(this.record)
      this.getModuleSwitch();
      this.getClientType();
      this.visible = true;
      this.getEveryoneUploadMaterialSwitch(this.record.client_id);
    },
    handleOk() {
      this.visible = false;
      // console.log('handleOk')
      // this.confirmLoading = true
      // axios.post(this.batchBindTagsUrl, {
      //   tag_id_list: this.tagIdList,
      //   chatroomname: this.dataIndex,
      //   token: sessionStorage.token
      // })
      //   .then((data) => {
      //     if (data.data.err_code === 0) {
      //       // console.log('重置免费一个群成功')
      //       // const dataSource = [...this.data]
      //       // const target = dataSource.find(item => item.client_id === clientId)
      //       // console.log('target', target)
      //       // if (target) {
      //       //   target['probation'] = 1
      //       //   console.log('dataSource', dataSource)
      //       //   this.data = dataSource
      //       // }
      //
      //       this.$emit('on-tag-changed', this.dataIndex, this.selectedTags)
      //       this.visible = false
      //       this.confirmLoading = false
      //     } else if (data.data.err_code === 50002) {
      //       console.log('token 不对，跳转登录')
      //       this.$router.push('/')
      //     }
      //   })
    },
    handleCancel() {
      // console.log('handleCancel')
      this.visible = false;
    },
    refreshToken() {
      axios
        .post(this.refreshTokenUrl, {
          client_id: this.record.client_id,
          token: sessionStorage.token,
        })
        .then((data) => {
          if (data.data.err_code === 0) {
            window.alert("刷新 token 成功");
          } else if (data.data.err_code === 50002) {
            console.log("token 不对，跳转登录");
            this.$router.push("/");
          }
        });
    },
    transform(value, fmt, ...args) {
      if (typeof value === "number") {
        // 如果是 秒 为单位就变为毫秒
        if (String(value).length === 10 || String(value).length === 11)
          value *= 1000;

        let date = new Date(value);
        var o = {
          "M+": date.getMonth() + 1, // 月份
          "d+": date.getDate(), // 日
          "h+": date.getHours(), // 小时
          "m+": date.getMinutes(), // 分
          "s+": date.getSeconds(), // 秒
          "q+": Math.floor((date.getMonth() + 3) / 3), // 季度
          S: date.getMilliseconds(), // 毫秒
          W: date.getDay(),
        };
        var weekMap = [
          "星期日",
          "星期一",
          "星期二",
          "星期三",
          "星期四",
          "星期五",
          "星期六",
        ];
        if (/(y+)/.test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            (date.getFullYear() + "").substr(4 - RegExp.$1.length)
          );
        }
        for (var k in o) {
          if (new RegExp("(" + k + ")").test(fmt) && k !== "W") {
            fmt = fmt.replace(
              RegExp.$1,
              RegExp.$1.length === 1
                ? o[k]
                : ("00" + o[k]).substr(("" + o[k]).length)
            );
          }
          if (new RegExp("(" + k + ")").test(fmt) && k === "W") {
            fmt = fmt.replace(RegExp.$1, weekMap[o[k]]);
          }
        }
        return fmt;
      } else return "";
    },
    moment,
    onChange(dates, dateStrings) {
      console.log(this.endTime);
      this.endTimestamp = parseInt(this.endTime.valueOf() / 1000);
      // console.log('From: ', dates[0].valueOf(), ', to: ', dates[1].valueOf())
      // console.log('From: ', dateStrings[0], ', to: ', dateStrings[1])
      // this.startTime = dates[0].valueOf()
      // this.endTime = dates[1].valueOf()
      // this.search()
    },
    onVIPExpiredTimeClick(infinite) {
      if (infinite) {
        this.endTimestamp = 0;
      }
      axios
        .post(this.refreshVIPExpireTimeUrl, {
          client_id: this.record.client_id,
          vip_expire_time: this.endTimestamp,
          token: sessionStorage.token,
        })
        .then((data) => {
          if (data.data.err_code === 0) {
            window.alert("刷新企业用户过期时间成功");
          } else if (data.data.err_code === 50002) {
            console.log("token 不对，跳转登录");
            this.$router.push("/");
          }
        });
    },
    setClientFuncs(record, func) {
      let clientId = record.client_id;
      axios
        .post(this.clientFuncs, {
          client_id: clientId,
          phone: record.phone,
          func: func,
          token: sessionStorage.token,
        })
        .then((data) => {
          if (data.data.err_code === 0) {
            const msg = data.data.content.msg;
            if (msg === "SUCCESS") {
              window.alert("开通成功");
            } else {
              window.alert(msg);
            }
          } else if (data.data.err_code === 50002) {
            console.log("token 不对，跳转登录");
            this.$router.push("/");
          }
        });
    },
    employeeClientAdd(clientId, username) {
      if (!username) {
        window.alert("请先通知客户给机器人发送暗号绑定机器人关系");
        return;
      }
      axios
        .post(this.employeeClientAddUrl, {
          client_id: clientId,
          username: username,
          token: sessionStorage.token,
          psw: "zvcasdkuagdgv214",
        })
        .then((data) => {
          if (data.data.err_code === 0) {
            window.alert("开通成功");
          } else if (data.data.err_code === 50002) {
            console.log("token 不对，跳转登录");
            this.$router.push("/");
          }
        });
    },
    exportAssignedCoupon(record){
      let baseUrl = global.DOMAIN + global.API_VERSION + this.exportAssignedCouponPostFix + '?'
      baseUrl += 'token' + '=' + record.token
      baseUrl += '&' + 'client_id' + '=' + record.client_id
      console.log('outputExcel', baseUrl)
      window.open(baseUrl, '_blank')
    },
    getCouponStat(record) {
      axios
        .post(this.couponStatUrl, {
          token: record.token,
        })
        .then((data) => {
          if (data.data.err_code === 0) {
            this.num_coupon_not_assigned = data.data.content.num_unassigned_coupon
          }
        });
    },
    getModuleSwitch() {
      this.module_switch = [];
      if (this.record.app) {
        let modules =
          this.record.module_switch || this.record.default_module_switch;
        Object.keys(global.modules[this.record.app]).forEach((item) => {
          this.module_switch.push([
            item,
            modules.indexOf(item) !== -1,
            global.modules[this.record.app][item],
          ]);
        });
      } else {
        this.$message.error("不是紫豆、友问币答或测试用户");
      }
    },
    changeModuleSwitch() {
      if (this.module_switch.some((item) => item[1] === true)) {
        let self = this;
        this.$confirm({
          title: "提示",
          content: "确定保存修改吗？",
          okText: "确认",
          cancelText: "取消",
          onOk() {
            let moduleList = [];
            self.module_switch.forEach((item) => {
              if (item[1]) {
                moduleList.push(item[0]);
              }
            });
            self.axios
              .post(self.changeModuleSwitchUrl, {
                token: sessionStorage.token,
                client_id: self.record.client_id,
                phone: self.record.phone,
                module_list: moduleList,
                client_type: self.clientType,
                change_staff: self.changeStaff,
              })
              .then((res) => {
                if (res.data.err_code === 0) {
                  self.$message.success("修改成功");
                  self.record.module_switch = moduleList;
                } else {
                  self.$message.error("修改失败");
                }
              })
              .catch((err) => {
                self.$message.error(err);
              });
          },
        });
      } else {
        this.$message.error("不能为空");
      }
    },
    checkAll(e) {
      this.module_switch.forEach((item) => {
        item[1] = e.target.checked;
      });
      this.flag++;
    },
    getClientType() {
      this.axios
        .post(this.getClientTypeUrl, {
          token: sessionStorage.token,
          client_id: this.record.client_id,
          phone: this.record.phone,
        })
        .then((res) => {
          if (res.data.err_code === 0) {
            this.clientType = res.data.content.result;
            this.clientR = res.data.content.nickname || undefined;
            if (this.clientType === 1) {
              this.clientType1 = "员工老板";
            } else if (this.clientType === 2) {
              this.clientType1 = "员工";
            } else if (this.clientType === 3) {
              this.clientType1 = "子账号";
            }
          }
        });
    },
    setAgentPhone(record) {
      if (!this.editPhone) {
        this.editPhone = true;
      } else {
        this.axios
          .post(this.setAgentPhoneUrl, {
            token: sessionStorage.token,
            phone: record.phone,
            client_id: record.client_id,
            agent_phone: this.agentPhone,
          })
          .then((res) => {
            if (res.data.err_code === 0) {
              this.$message.success("操作成功");
              this.record.agent_phone = this.agentPhone || undefined;
              if (this.record.agent_phone) {
                this.editPhone = false;
              }
            } else {
              this.$message.error("操作失败");
            }
          });
      }
    },
    setMaterialEnvoy() {
      const self = this;
      this.$confirm({
        content: "确定设为素材小使者?",
        onOk() {
          self.axios
            .post(self.setMaterialEnvoyUrl, {
              token: sessionStorage.token,
              phone: self.record.phone,
              client_id: self.record.client_id,
            })
            .then((res) => {
              if (res.data.err_code === 0) {
                self.$message.success("操作成功");
              } else {
                self.$message.success("操作失败");
              }
            });
        },
      });
    },
    setMiniParamsSwitch(checked) {
      this.axios
        .post(this.setMiniParamsSwitchUrl, {
          token: sessionStorage.token,
          client_id: this.record.client_id,
          switch: checked,
        })
        .then((res) => {
          if (res.data.err_code === 0) {
            this.$message.success("操作成功");
            this.record.mini_params_switch = checked;
          } else {
            this.$message.error("操作失败");
          }
        });
    },
    getChatroomExcel(record) {
      let baseUrl =
        this.getChatroomExcelUrl +
        "?token=" +
        sessionStorage.token +
        "&client_id=" +
        record.client_id;
      window.open(baseUrl, "_blank");
    },
    // 上传普通带参群发excel
    uploadCommonMiniParams(info) {
      this.uploadMiniParams(info, 0)
    },
    // 上传参数被编码的带参群发excel
    uploadDecodeMiniParams(info) {
      this.uploadMiniParams(info, 1)
    },
    uploadMiniParams(info, paramsType) {
      let formData = new FormData();
      formData.append("file", info.file);
      formData.append("token", sessionStorage.token);
      formData.append("client_id", this.record.client_id);
      formData.append("params_type", paramsType);

      this.axios.post(this.setMiniParamsUrl, formData).then((res) => {
        if (res.data.err_code === 0) {
          this.$message.success("操作成功");
        } else {
          this.$message.error("操作失败");
        }
      });
      this.fileList = [];
    },
    confirmDeleteAllCoupon(record){
      console.log(this.deleteAllCouponUrl)
      axios
        .post(this.deleteAllCouponUrl, {
          token: this.record.token,
        })
        .then((data) => {
          console.log(data)
          if (data.data.err_code === 0) {
            window.alert("成功删除" + data.data.content.num_deleted_coupon + "个优惠券");
          } 
        });
    },
    cancelDeleteAllCoupon(){

    },
    uploadCoupon(){
      if(this.showUploadBox == 0){
        this.showUploadBox = 1;
      }
      else{
        this.showUploadBox = 0;
      }
      
    },
    uploadCouponExcel(info) {
      console.log(info)
      const status = info.file.status;
      let formData = new FormData();
      formData.append("file", info.file);
      formData.append("token", this.record.token);
      formData.append("client_id", this.record.client_id);

      console.log(formData)
      axios.post(this.uploadCouponExcelUrl, formData)
      // axios.post("http://127.0.0.1:8000/" + this.uploadCouponExcelPostFix, formData)
      .then((res) => {
        console.log(res);
        if (res.data.err_code === 0) {
          this.$message.success("操作成功");
        } else {
          this.$message.error("操作失败");
        }
      });
      
      if (status === 'done') {
        this.$message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === 'error') {
        this.$message.error(`${info.file.name} file upload failed.`);
      }
    },
  
  },
};
</script>

<style scoped>
.modules {
  padding: 10px;
  border: 1px solid #e8e8e8;
}
.info {
  font-size: 13px;
  color: #999999;
}
</style>
